module.exports = __webpack_public_path__ + "img/map.0a104cd6.png";